import React from 'react';
import { forEach, get, has, isPlainObject, omit } from 'lodash';
import cx from 'classnames';
import JSONUtils from '../../../../lib/JSONUtils';
import TransformsUtils from '../../../../lib/TransformsUtils';
import { getEditorLanguage } from '../../../elements/editors/monaco/MonacoEditorUtils';
import Constants from '../../../../Constants';
import { SamplesPayloadTab, TestTab } from './components';
import styles from './DestinationPayload.module.scss';
import { SegmentedControl } from 'new/elements/SegmentControl/SegmentControl';

class DestinationPayload extends React.Component {
  state = {
    activeTab: 0,
  };

  componentDidMount = () => {
    if (this.props.samples) {
      this.refreshPayload();
    }
  };

  componentDidUpdate = (prevProps) => {
    if (!prevProps.samples && this.props.samples) {
      this.refreshPayload();
    }
    // If testing tab is disabled and it was active, switch to sample payload tab
    if (this.props.disableTestingTab && this.state.activeTab === 1) {
      this.setState({ activeTab: 0 });
    }
  };

  refreshPayload = () => {
    let { dataSetId, samples } = this.props;
    let txObject = TransformsUtils.getTransformSpecForFlatToNested();
    this.props.fetchTransformedPayloadFromEditorForRest(txObject, samples, dataSetId);
  };

  _generateBatchCode = () => {
    const { previewPayload, sinkConfig, contentType } = this.props;
    let data = [];

    const groupingAlgo = has(sinkConfig, 'ui.batch_algo') ? sinkConfig['ui.batch_algo'] : null;
    const otherProps = has(sinkConfig, 'ui.body.transform.function')
      ? sinkConfig['ui.body.transform.function']
      : '{}';
    const payloadFieldName = has(sinkConfig, 'ui.batch_fieldname')
      ? sinkConfig['ui.batch_fieldname']
      : 'data';

    forEach(previewPayload, (sample) => {
      const excludes = get(sinkConfig, 'mapping.excludes', []);
      const code = JSONUtils.parseToFormat(
        isPlainObject(sample) ? omit(sample, excludes) : sample,
        contentType,
      );
      data.push(JSONUtils.parseJson(code));
    });

    if (groupingAlgo && groupingAlgo === Constants.GROUPING_ALGO[1].value) {
      let optionalJSON = JSONUtils.isJSON(otherProps) ? JSONUtils.parseJson(otherProps) : {};
      let payloadKeyName = payloadFieldName || 'data';
      data = {
        ...optionalJSON,
        [payloadKeyName]: data,
      };
    }

    let batchCode = null;
    if (
      !groupingAlgo ||
      (groupingAlgo && groupingAlgo.value !== Constants.GROUPING_ALGO[2].value)
    ) {
      batchCode = JSONUtils.parseToFormat(data, contentType);
    }
    return batchCode;
  };

  handleTabChange = (_event, newValue) => {
    this.setState({ activeTab: newValue });
  };

  render() {
    const {
      description,
      panelHeading,
      previewPayload,
      sinkConfig,
      error,
      contentType,
      isLoadingProbeSample,
      samples,
      selectedCredentialId,
      dataSchema,
      selectedConnection,
      onToggleDestinationDraft,
      addTemplateConfigForTestingSamples,
      disableTabs,
      disableTestingTab,
      parentDataSet,
      parentDataSetSamples,
    } = this.props;
    const { activeTab } = this.state;
    const batchMode = (sinkConfig && sinkConfig['batch.mode']) || false;
    const groupingAlgo = has(sinkConfig, 'ui.batch_algo') ? sinkConfig['ui.batch_algo'] : null;
    const batchedCode = batchMode ? this._generateBatchCode() : null;
    const editorLanguage = getEditorLanguage(contentType);

    return (
      <div className={cx('api-response-holder', styles.container)}>
        {!disableTabs && (
          <div className={styles.tabs}>
            <SegmentedControl
              controls={[
                {
                  value: 0,
                  label: 'Sample Payload',
                },
                {
                  value: 1,
                  label: `${disableTestingTab ? 'Test (Coming Soon)' : 'Test'}`,
                  disabled: disableTestingTab,
                },
              ]}
              value={activeTab}
              onControlChange={this.handleTabChange}
              centered
              defaultValue={activeTab}
              className={styles.segmented_control}
            />
          </div>
        )}

        {activeTab === 0 && (
          <SamplesPayloadTab
            description={description}
            error={error}
            isLoadingProbeSample={isLoadingProbeSample}
            previewPayload={previewPayload}
            batchMode={batchMode}
            groupingAlgo={groupingAlgo}
            editorLanguage={editorLanguage}
            batchedCode={batchedCode}
            sinkConfig={sinkConfig}
            contentType={contentType}
            panelHeading={panelHeading}
            refreshPayload={this.refreshPayload}
          />
        )}

        {activeTab === 1 && (
          <TestTab
            description="Testing will send real data to your destination system and may cause changes. Use with caution."
            error={error}
            isLoadingProbeSample={isLoadingProbeSample}
            samples={samples}
            batchMode={batchMode}
            groupingAlgo={groupingAlgo}
            editorLanguage={editorLanguage}
            batchedCode={batchedCode}
            sinkConfig={sinkConfig}
            contentType={contentType}
            panelHeading={panelHeading}
            refreshPayload={this.refreshPayload}
            selectedCredentialId={selectedCredentialId}
            dataSchema={dataSchema}
            selectedConnection={selectedConnection}
            onToggleDestinationDraft={onToggleDestinationDraft}
            addTemplateConfigForTestingSamples={addTemplateConfigForTestingSamples}
            parentDataSet={parentDataSet}
            parentDataSetSamples={parentDataSetSamples}
          />
        )}
      </div>
    );
  }
}

export default DestinationPayload;
